import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { CloseIcon } from '../../assets/images';
import './styles.scss';

function BroadcastBanner({ activeMessages, handleShow }) {
  const [showBanner, setshowBanner] = useState(true);

  useEffect(() => {
    if (showBanner) {
      toast.custom(t => (
        <div className={'broadcast_notification'}>
          <img
            src={require('../../assets/images/info.svg').default}
            style={{ width: '20px', marginLeft: '20px' }}
          />
          <div className="broadcast_notification_message">
            <span className="message_display">
              <p>{activeMessages.message}</p>
            </span>
          </div>
          <button
            className="btn btn-link "
            onClick={() => handleShow()}
            style={{ fontSize: '12px', display: 'bold' }}>
            Details
          </button>
          <button
            onClick={() => {
              setshowBanner(false);
              toast.dismiss(t.id);
            }}
            className="broadcast_close">
            <CloseIcon />
          </button>
        </div>
      ));
    }
  }, []);
}

export default BroadcastBanner;
